
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artefacts/[id]/[slug]",
      function () {
        return require("private-next-pages/artefacts/[id]/[slug].tsx");
      }
    ]);
  